import { AxiosError, AxiosResponse } from 'axios'
import lodash from 'lodash'
import { getRequestTime } from '..'

export const apiReportResponseInterceptors = {
  success: (response: AxiosResponse) => {
    reportLog(response)
    return response
  },
  fail: (error: AxiosError) => {
    reportLog(error.response!)
    throw error
  }
}

function reportLog(response: AxiosResponse) {
  if (!response) {
    return
  }

  try {
    const traceId = getTraceId(response.config.url!, response)
    const snapshot = formatApiSnapshot({
      response,
      pickRequestHeaders: ['x-xt-client-info'],
      pickResponseHeaders: ['date', 'x-xt-trace-id'],
      sensitiveDataFields: ['password', 'newPassword', 'confirmNewPassword']
    })
    const success = response.status >= 200 && response.status < 300

    if (window.__bl) {
      window.__bl.api(
        formatApi(response.request?.responseURL, ['password', 'newPassword', 'confirmNewPassword']),
        success,
        Date.now() - getRequestTime(),
        response.status,
        success ? '' : JSON.stringify(response.data),
        getRequestTime(),
        traceId,
        '',
        encodeURIComponent(JSON.stringify(snapshot))
      )
    }
  } catch (error) {
    console.error('api日志上报错误', JSON.stringify(error))
  }
}

const replaceTag = '__hide__'

/** 获取TraceId */
function getTraceId(url: string, response: AxiosResponse) {
  const pathWhiteList = ['/mocks/', '/date']
  if (pathWhiteList.some(path => url.includes(path))) {
    return ''
  }
  return response.headers['x-xt-trace-id']
}

function formatApiSnapshot(options: {
  response: AxiosResponse
  /** 自定义哪些像响应头数据上报 */
  pickResponseHeaders?: string[]
  /** 自定义哪些像请求头数据上报 */
  pickRequestHeaders?: string[]
  /** 敏感数据字段，会在上报时将字段值替换为"__hide__" */
  sensitiveDataFields?: string[]
}) {
  const { response, sensitiveDataFields, pickRequestHeaders, pickResponseHeaders } = options

  return {
    method: response.config.method,
    originApi: formatApi(response.request?.responseURL, sensitiveDataFields),
    params: formatData(
      JSON.parse(typeof response.config.data === 'string' && response.config.data ? response.config.data : '{}'),
      sensitiveDataFields
    ),
    reqHeaders: formatHeaders(response.config.headers ?? {}, pickRequestHeaders),
    resHeaders: formatHeaders(response.headers, pickResponseHeaders)
  }
}

function formatApi(api: string, dataDesensitization?: string[]) {
  if (!Array.isArray(dataDesensitization)) return api

  try {
    const url = new URL(api)
    const searches = url.searchParams
    dataDesensitization.forEach(field => {
      if (searches.has(field)) {
        searches.set(field, replaceTag)
      }
    })

    return url.toString()
  } catch {
    return api
  }
}

function formatData(data: Record<string, any>, dataDesensitization?: string[]) {
  if (!data || !Array.isArray(dataDesensitization)) return data

  lodash.forOwn(data, (_value, key, object) => {
    if (dataDesensitization.includes(key)) {
      object[key] = replaceTag
    }
  })

  return data
}

function formatHeaders(headers: Record<string, any>, pickList?: string[]) {
  if (!headers || !Array.isArray(pickList)) return headers as Record<string, string>

  return lodash.pick(headers, pickList)
}
